import BankSidebar from '@monetr/interface/components/Layout/BankSidebar';

export default function Sidebar(): React.JSX.Element {
  // const isMobile = useIsMobile();
  // if (isMobile) {
  //   return <MobileSidebar />;
  // }

  return <BankSidebar />;
}
